import styled from 'styled-components';

export const StyledActionsWrap = styled.div`
  display: flex;
  align-items: center;
`;
